import { render, staticRenderFns } from "./user_avatar.vue?vue&type=template&id=af7ab36a&scoped=true&"
import script from "./user_avatar.vue?vue&type=script&lang=js&"
export * from "./user_avatar.vue?vue&type=script&lang=js&"
import style0 from "./user_avatar.vue?vue&type=style&index=0&id=af7ab36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7ab36a",
  null
  
)

export default component.exports